export const workspaceProfileAdapter = workspaceProfile => ({
  id: workspaceProfile.id,
  operations: workspaceProfile.operations,
  name: workspaceProfile.name,
  workspace: workspaceProfile.workspace
})
